import ArticleDetail from './ArticleDetail'

export default ArticleDetail
